__turbopack_context__.v({
  "tab": "tabs-module-scss-module__ujAjda__tab",
  "tab-indicator": "tabs-module-scss-module__ujAjda__tab-indicator",
  "tabs": "tabs-module-scss-module__ujAjda__tabs",
});
